import {SimpleModule} from 'ca-middleware';
export class ModuleGisPlot extends SimpleModule {

    constructor() {
        super();
    }

    public configureView() {
        this.addComponent('LayoutGisPlot');
    }

    public configureService() {}
}
